import { Link } from 'react-router-dom';
import type { Post } from '../../../types/blog';

type PostCardProps = {
  post: Post;
};

export default function PostCard({ post }: PostCardProps) {
  return (
    <article className="bg-white rounded-lg shadow-sm overflow-hidden">
      <div className="p-6">
        <h2 className="text-xl font-semibold mb-2">
          <Link 
            to={`/blog/${post.slug}`}
            className="text-gray-900 hover:text-indigo-600"
          >
            {post.title}
          </Link>
        </h2>
        <p className="text-gray-600 mb-4">{post.excerpt}</p>
        <div className="flex justify-between items-center text-sm text-gray-500">
          <time>{new Date(post.created_at).toLocaleDateString()}</time>
          {post.status === 'draft' && (
            <span className="px-2 py-1 bg-gray-100 rounded-full">草稿</span>
          )}
        </div>
      </div>
    </article>
  );
}